import { Injectable } from '@angular/core';
import { Map, View } from "ol";
import { transform } from 'ol/proj';
import BingMaps from "ol/source/BingMaps";
import TileLayer from "ol/layer/Tile";
import { defaults as defaultControls, ScaleLine } from "ol/control";
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import TileWMS from 'ol/source/TileWMS';

const url = 'http://www.bing.com/api/maps/mapcontrol?callback=__onBingLoaded&branch=release';
let db;

@Injectable({
  providedIn: 'root'
})

export class MapService {
  private static promise;
  private capastematicas_const;
  private getCapa;
  private urlGeoserver = environment.geoserverBaseUrl;
  private pybackend = environment.backend_python;

  private CapaMapaHome: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public CapaMapaHome$: Observable<any[]> = this.CapaMapaHome.asObservable();
  
  constructor( private http: HttpClient){
  }

  updateCapaHome(capa) {
    console.log(capa)
    this.CapaMapaHome.next(capa);
  }

  load() {
      // First time 'load' is called?
      if (!MapService.promise) {
          // Make promise to load
          MapService.promise = new Promise( resolve => {
              // Set callback for when bing maps is loaded.
              window['__onBingLoaded'] = (ev) => {
                  resolve('Bing Maps API loaded');
              };
              const node = document.createElement('script');
              node.src = 'http://www.bing.com/api/maps/mapcontrol?callback=__onBingLoaded&branch=release';
              node.type = 'text/javascript';
              node.async = true;
              node.defer = true;
              document.getElementsByTagName('head')[0].appendChild(node);
              console.log('Esta saliendo....')

          });

      }

      // Always return promise. When 'load' is called many times, the promise is already resolved.

      return MapService.promise;
  }

  public get LayerSelect() {
    // send current user or load data from backend using token
    return this.getLayers();
  }

  public get CapasAnalysis(){
    return this.getCapasAnalysis();
  }
  
  public getBaseLayers(){
    const basemaps = [{ value: 'AerialWithLabelsOnDemand', label: 'Aérea Bing con Etiquetas', checked: true },
    { value: 'OS', label: 'Open Street Map' },
    { value: 'RoadOnDemand', label: 'Calles Bing' },
    { value: 'Aerial', label: 'Aérea Bing' }]
    
    return basemaps
  }

  private getLayers(){
    const capas_tematicas = [
      {value:"bioap:dom_abastecimiento_agua_potable_avc5",label:"Abastecimiento de Agua Potable",name:"abastecimiento_agua_potable_avc5",grupo:15,style:'agua-potable.png', checked: ""},
      {value:"bioap:dom_aii",label:"Area de Influencia",name:"aii",grupo:11, style:'',checked: ""},
      {value:"bioap:dom_areas_avc1",label:"AVC1",name:"areas_avc1",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_avc2",label:"AVC2",name:"areas_avc2",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_avc3",label:"AVC3",name:"areas_avc3",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_avc4",label:"AVC4",name:"areas_avc4",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_avc5",label:"AVC5",name:"areas_avc5",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_avc6",label:"AVC6",name:"areas_avc6",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc1",label:"Áreas de Manejo AVC 1",name:"areas_manejo_avc1",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc2",label:"Áreas de Manejo AVC 2",name:"areas_manejo_avc2",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc3",label:"Áreas de Manejo AVC 3",name:"areas_manejo_avc3",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc4",label:"Áreas de Manejo AVC 4",name:"areas_manejo_avc4",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc5",label:"Áreas de Manejo AVC 5",name:"areas_manejo_avc5",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_areas_manejo_avc6",label:"Áreas de Manejo AVC 6",name:"areas_manejo_avc6",grupo:14,style:'',checked: ""},
      {value:"bioap:dom_camara_trampa",label:"Cámara Trampa",name:"camara_trampa",grupo:15,style:'camara-trampa.png' , checked: ""},
      {value:"bioap:dom_drenajes_avc4",label:"Drenajes AVC4",name:"drenajes_avc4",grupo:13,style:'',checked: ""},
      {value:"bioap:dom_fauna",label:"Fauna",name:"fauna",grupo:15,style:'fauna.png' , checked: ""},
      {value:"bioap:dom_flora",label:"Flora",name:"flora",grupo:15,style:'monitoreo-flora.png' , checked: ""},
      {value:"bioap:dom_limite_predio",label:"Límite Predial",name:"limite_predio",grupo:11,style:'',checked: ""},
      {value:"bioap:dom_monitoreo_fauna_avc1",label:"Monitoreo Fauna ",name:"monitoreo_fauna_avc1",grupo:15,style:'monitoreo-fauna.png' , checked: ""},
      {value:"bioap:dom_monitoreo_flora_avc1",label:"Monitoreo Flora ",name:"monitoreo_flora_avc1",grupo:15,style:'monitoreo-flora.png' , checked: ""},
      // {value:"bioap:dom_parcela_permanente_avc1",label:"Parcela AVC1 ",name:"parcela_permanente_avc1",grupo:11,style:'',checked: ""},
      {value:"bioap:dom_paso_fauna_avc1",label:"Paso Fauna",name:"paso_fauna_avc1",grupo:15,style:'paso-de-fauna.png' , checked: ""},
      {value:"bioap:dom_pesca_avc5",label:"Pesca Pesca",name:"pesca_avc5",grupo:15,style:'pesca.png' , checked: ""},
      {value:"bioap:dom_punto_avc5",label:"Punto Punto",name:"punto_avc5",grupo:14,style:'arqueologia-icon.png' , checked: ""},
      {value:"bioap:dom_recreacion_avc5",label:"Registros Recreacion",name:"recreacion_avc5",grupo:14,style:'Recreacion.png' , checked: ""},
      {value:"bioap:dom_registros_arqueologicos_avc6",label:"Registros Arqueologicos",name:"registros_arqueologicos_avc6",grupo:14,style:'arqueologia-icon.png' , checked: ""},
      {value:"bioap:dom_uso_agropecuario_avc5",label:"Uso Agropecuario",name:"uso_agropecuario_avc5",grupo:14,style:'agropecuario.png' , checked: ""},
      {value:"bioap:dom_cober_tierra",label:"Coberturas Terrestres",name:"cober_tierra",grupo:12,style:'',checked: ""},
    ]
    return capas_tematicas;
  };

  private getCapasAnalysis(){
    const CapasAnalysis = [
      {value:"bioap:avc_1",label:"AVC 1",name:"avc_1",grupo:1,style:'',checked: "",description:"descripcion_avc1",info:[{label: "Manejo", codigo:"cmavc1"},{label: "Área AVC",codigo:"caavc1"},{label: "Área manejo",codigo:"cmaavc1"}],cob:"avc_1_encontrado"},
      {value:"bioap:avc_2",label:"AVC 2",name:"avc_2",grupo:1,style:'',checked: "",description:"descripcion_avc2",info:[{label: "Manejo", codigo:"cmavc2"},{label: "Área AVC",codigo:"caavc2"},{label: "Área manejo",codigo:"cmaavc2"}],cob:"avc_2_encontrado"},
      {value:"bioap:avc_3",label:"AVC 3",name:"avc_3",grupo:1,style:'',checked: "",description:"descripcion_avc3",info:[{label: "Manejo", codigo:"cmavc3"},{label: "Área AVC",codigo:"caavc3"},{label: "Área manejo",codigo:"cmaavc3"}],cob:"avc_3_encontrado"},
      {value:"bioap:avc_4",label:"AVC 4",name:"avc_4",grupo:1,style:'',checked: "",description:"descripcion_avc4",info:[{label: "Manejo", codigo:"cmavc4"},{label: "Área AVC",codigo:"caavc4"},{label: "Área manejo",codigo:"cmaavc4"}],cob:"avc_4_encontrado"},
      {value:"bioap:avc_5",label:"AVC 5",name:"avc_5",grupo:1,style:'',checked: "",description:"descripcion_av5",info:[{label: "Manejo", codigo:"cmavc5"},{label: "Área AVC",codigo:"caavc5"},{label: "Área manejo",codigo:"cmaavc5"}],cob:"avc_5_encontrado"},
      {value:"bioap:avc_6",label:"AVC 6",name:"avc_6",grupo:1,style:'',checked: "",description:"descripcion_av6",info:[{label: "Manejo", codigo:"cmavc6"},{label: "Área AVC",codigo:"caavc6"},{label: "Área manejo",codigo:"cmaavc6"}],cob:"avc_6_encontrado"},
      {value:"bioap:avc_coberturas",label:"AVC coberturas",name:"avc_coberturas",grupo:1,style:'',checked: "",description:"cdc",info:[],cob:"cobertura"},
      {value:"bioap:deforestacion_2013_2016",label:"Deforestacion 2013 - 2016",name:"deforestacion_2013_2016",grupo:1,style:'',checked: "",description:"",info:[],cob:"ano"},
      {value:"bioap:distribucion_potencial_anfibios",label:"DISTRIBUCION POTENCIAL ANFIBIOS",name:"Distribucion_potencial_anfibios",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
      {value:"bioap:distribucion_potencial_aves",label:"DISTRIBUCION POTENCIAL AVES",name:"Distribucion_potencial_aves",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
      {value:"bioap:distribucion_potencial_mamiferos",label:"DISTRIBUCION POTENCIAL MAMFEROS",name:"Distribucion_potencial_mamiferos",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
      {value:"bioap:distribucion_potencial_reptiles",label:"DISTRIBUCION POTENCIAL REPTILES",name:"Distribucion_potencial_reptiles",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
      {value:"bioap:lb_ecorregion",label:"LB Ecorregiones",name:"lb_ecorregiones",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
      {value:"bioap:lb_hidrografia",label:"LB Hidrografia",name:"lb_hidrografia",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
      {value:"bioap:lb_hotspot",label:"LB Hotspot",name:"lb_hotspot",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
      {value:"bioap:lb_resguardos_indigenas",label:"LB Resguardos Indigenas",name:"lb_resguardos_indigenas",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
      {value:"bioap:lb_suelos",label:"LB suelos",name:"lb_suelos",grupo:1,style:'',checked: "",description:"",info:[],cob:""}
      ];
      return CapasAnalysis
  }

  public readFileContent(file: File) {
    let fileReader: FileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);

    let observable =  new Observable((observer: Observer<any>) => {
      fileReader.onloadend = () => {
        observer.next(fileReader.result);
        observer.complete();
      };
    })
    return observable
  }

  private crearMapa(targetId){
      const  LayerBase = new TileLayer({
        visible: true,
        preload: Infinity,
        source: new BingMaps({
          key:
            "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j",
          imagerySet: "AerialWithLabelsOnDemand",
        })
      })
      LayerBase.set('name', 'CapaBase');

      var view = new View({
        center: transform([-74, 4], 'EPSG:4326', 'EPSG:3857'),
        zoom: 5,
      });
      // se hace push al objeto layers, el cual ya contiene toda la informacion de las capas bing maps
      const map = new Map({
        controls: defaultControls().extend([
          new ScaleLine({
            units: "metric",
          })
        ]),
        layers:  [LayerBase],
        target: targetId,
        view: view,
      });

      return map
  } 

  public nuevoMapa(targetId){
    return this.crearMapa(targetId);
  }

  agregarCapa(capa, filtro, map){
    let paramsC = {LAYERS: capa.value}
    if(filtro && filtro.selectedEmpresas.length > 0){
      const ids = filtro.selectedEmpresas.map( f => f.item_id)
      paramsC['CQL_FILTER'] = `id_empresa IN (${ids.join()})`
    }
    var source_wms = new TileWMS({
      url: this.urlGeoserver+'/wms',
      params: paramsC,
      serverType: 'geoserver',
    });
    var l = new TileLayer({
      visible: true,
      opacity: 1,
      //crossOrigin: 'anonymous',
      source: source_wms,
    });
    l.set('name', capa.name);
    map.getLayers().insertAt(2,l);
  }

  public async CallLayers(layer, filtro){
    let lys = layer.value
    const resp = await this.getFromDB(lys);
    if(typeof resp === 'object'){
      if(filtro && filtro.selectedEmpresas.length > 0){
        const ids = filtro.selectedEmpresas.map( f => f.item_id)
        resp['content']['features'] = resp['content']['features'].filter( feat => ids.includes(feat.properties.id_empresa))
      }
      return resp
    }
    const params={
      service: "WFS",
      version: '1.0.0',
      request: "GetFeature",
      typeName: lys,
      outputFormat: 'application/json'
    }
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
        httpParams = httpParams.append(key, params[key]);
    });
    if(filtro && filtro.selectedEmpresas.length > 0){
      let empresas = filtro.selectedEmpresas.map(item => item.item_id)
      params['cql_filter'] = `id_empresa IN (${empresas.join()})`
    }
    const url = `${environment.baseUrl}`

    const response = await this.http.get(
      url,{
        params:httpParams
      }
      ).toPromise()
    
    // const store = {'id': layer.value, name:layer.name, value: JSON.parse(JSON.stringify(response))}
    // this.addToDB(store)

    return JSON.parse(JSON.stringify(response));
  }

  public async CallLimites(filtro){
    let lys = "bioap:dom_limite_predio"
    let empresas = filtro.selectedEmpresas.map(item => item.item_id)
    const params={
      service: "WFS",
      version: '1.0.0',
      request: "GetFeature",
      typeName: lys,
      outputFormat: 'application/json',
      cql_filter: `id_empresa IN (${empresas.join()})`
    }
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
        httpParams = httpParams.append(key, params[key]);
    });
    const url = `${environment.baseUrl}`

    const response = await this.http.get(
      url,{
        params:httpParams
      }
      ).toPromise()

    return JSON.parse(JSON.stringify(response));
  }

  public async callLayer(filtro, lyr, cql=''){
    let lys = lyr
    let empresas = filtro.selectedEmpresas.map(item => item.item_id)
    const params={
      service: "WFS",
      version: '1.0.0',
      request: "GetFeature",
      typeName: lys,
      outputFormat: 'application/json',
      cql_filter: `id_empresa IN (${empresas.join()})${cql}`
    }
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
        httpParams = httpParams.append(key, params[key]);
    });
    const url = `${environment.baseUrl}`

    const response = await this.http.get(
      url,{
        params:httpParams
      }
      ).toPromise()

    return JSON.parse(JSON.stringify(response));
  }

  public async connect(){
    await this.connectDB();
  }

  private async connectDB(){

      const request = await window.indexedDB.open('capasRedOcelote');
  
      request.addEventListener('error', e => {
          console.log('Error');
      })
      request.addEventListener('upgradeneeded', e => {
          db = request.result;
          const objectStore = db.createObjectStore('capas', { keyPath: 'id' })
          objectStore.createIndex('name', 'name', { unique: true });
          objectStore.createIndex('content', 'content', { unique: false });
      })

      request.addEventListener('success', () => {
          db = request.result;
          console.log('DB created')
      })
  
  }

  private addToDB(input){
    if(db){
      const transaction = db.transaction(['capas'], 'readwrite');
      const objectStore = transaction.objectStore('capas');
      const newRecord = {id: input.id, name: input.name, content: input.value};
      const request = objectStore.add(newRecord);

      request.addEventListener('success', () => {
          input.value = '';
      })

      transaction.addEventListener('error', () => {
          return;
      })
    }
  }

  private async getFromDB(id){
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(["capas"], 'readonly');
      const objectStore = transaction.objectStore("capas");
      const request = objectStore.get(id);

      request.onsuccess = async (event) => {
        // Do something with the request.result!
        let content = event.target.result;
        resolve(content);
      };
      request.onerror = function(event) {
        reject(`error in cursor request ${event.target.errorCode}`);
      }
    })
  }


  public async getTablaDominios(codigo) : Promise<string>{
    return new Promise( async (resolve, reject) => {
      let url = `${environment.geoserverBaseUrl}/bioap/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=bioap:tabla_dominios_bd&CQL_FILTER=id_dom%20IN%20('${codigo}')&outputFormat=application%2Fjson`;
      const fetchResult = fetch(`${url}`)
      const response = await fetchResult
      let jsonData = await response.json();
      jsonData = JSON.parse(jsonData.contents)
      if(jsonData.totalFeatures > 0){
        const result = jsonData.features[0].properties.descripcion
        resolve(result)
      }else{
        resolve("")
      }
    })
  }

  public getColumnsFromCapas(capa): Promise<any[]>{
      let url = `${this.pybackend}table/${capa}`;
      return this.http.get<any[]>(url).toPromise()
  }

  public getDataFromCapa(capa, column1, column2, column3, companies): Promise<Object>{
    const u = `${this.pybackend}aggregate/${capa}/${column1}/${column2}`
    let url = column3 ? `${u}/${column3}` : u;
    let body = {
      "companies" : companies.selectedEmpresas.map(item => item.item_id)
    }
    return this.http.post(url, body).toPromise()
  }

  public async getCardsData(capa, category, companies): Promise<Object>{
    if(companies.selectedEmpresas.length > 0){
      let url = `${this.pybackend}cards`;
      let body = {
        "companies" : companies.selectedEmpresas.map(item => item.item_id),
        "capa": capa
      }

      if(category){
        body['category'] = category;
      }
      return this.http.post(url, body).toPromise()
    }
    
  }

}
